<template>
  <div class="owal-traininig-tool-detection-banner__container">
    <owal-banner>
         <owal-event-banner-timeline
          :unix-epoch-milliseconds="unixOffsetFromTimestamp(track.track_start)"
          dot-color="red"
        />
        <div class="submitted" v-show="hidden">Submitted! <button @click="hidden = !hidden">show</button></div>
        <div class="owal flex row" v-show="!hidden">
          <div class="btn-grp" v-if="track.track_detections.length > 0">
            <button @click="selectAll">select all</button>
            <button @click="clear">clear</button>
            <button @click="hide">hide track without verifying</button>
            <button @click="verify">verify track</button>
          </div>
          <div class="scrollable" @drop="onDrop($event, track)" @dragenter.prevent @dragover.prevent>
            <div
              draggable="true"
              @drag="scrollWindow($event)"
              @dragstart="startDrag($event, step)"
              @dragend="endDrag($event, step)"
              v-for="step in track.track_detections"
              :key="step.step_id"
              :class="{ selected: stepState[step.step_id], unselected: !stepState[step.step_id]} "
              @click="toggleState(step.step_id)">
              <owal-event-banner-poster-frame
                :poster-frame-small="`https://svc-faces-track-img.api.owal.io/track/${track.track_uuid}/step_id/${step.step_id}?cropped=1`"
                :poster-frame-large="`https://svc-faces-track-img.api.owal.io/track/${track.track_uuid}/step_id/${step.step_id}`"
                :title="`${cameraForUUID(step.camera_uuid).description}`"
                :subtitle="`${step.captured_at}`"
                :buttons="posterButtons"
                :vertical="true"
              />
              click to select
            </div>
            <div v-if="merging">
              <owal-spinner-logo />
            </div>
          </div>
        </div>
    </owal-banner>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import { updateTracks, verifyTrack } from '@/libraries/api/faces'
import { OwalButtonConfiguration } from '@/libraries/owal-ui'
import OwalEventBannerPosterFrame from '@/libraries/owal-ui/banners/OwalEventBannerPosterFrame'
import OwalBanner from '@/libraries/owal-ui/banners/OwalBanner'
import OwalEventBannerTimeline from '@/libraries/owal-ui/banners/OwalEventBannerTimeline'
import OwalSpinnerLogo from '@/libraries/owal-ui/spinners/OwalSpinnerLogo'

export default {
  name: 'OwalTrainingToolDetectionBanner',
  components: {
    OwalSpinnerLogo,
    OwalBanner,
    OwalEventBannerTimeline,
    OwalEventBannerPosterFrame,
  },
  /**
   * @prop {Object} face The face detected that needs a confirmation.
   * @prop {Number} index The index of the detection.
   * @prop {Boolean} shapes Does the banner show shapes on the poster?
   * @prop {Boolean} clahe Does the banner use Cntrast Limited Adaptive histogram equalization?
   */
  props: {
    track: {
      Object,
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  data () {
    return {
      hidden: false,
      toDrag: new Set(),
      stepState: {},
      base64Image: null,
      merging: false
    }
  },
  async created() {
    // try {
    //   const b64 = await this.loadImageAsBase64(this.cropped_frame_uri)
    //   this.base64Image = b64
    // } catch (e) {
    //   console.error(e)
    //   this.base64Image = this.cropped_frame_uri
    // }
    this.clear()
  },
  methods: {
    selectAll() {
      this.track.track_detections.forEach(step => {
        this.toDrag.add(step.step_id)
        this.$set(this.stepState, step.step_id, true)
      })
    },
    clear() {
      this.toDrag = new Set()
      this.track.track_detections.forEach(step => {
        this.$set(this.stepState, step.step_id, false)
      })
    },
    hide() {
      this.$emit('track-hidden')
    },
    async verify() {
      await verifyTrack({ domainUUID: this.domainUUID, trackUUID: this.track.track_uuid })
      this.$emit('track-verified')
    },
    toggleState(stepId) {
      this.stepState[stepId] = !this.stepState[stepId]
      if (this.stepState[stepId]) {
        this.toDrag.add(stepId)
      } else {
        this.toDrag.delete(stepId)
      }
    },
    startDrag(event, item) {
      if (this.toDrag.size === 0) {
        return
      }
      event.dataTransfer.dropEffect = 'move'
      event.dataTransfer.effectAllowed = 'move'
      event.dataTransfer.setData('steps', JSON.stringify(this.track.track_detections.filter(step => this.toDrag.has(step.step_id))))
      event.dataTransfer.setData('trackUuid', JSON.stringify(this.track.track_uuid))
      console.log(event, this.toDrag)
    },
    endDrag(event, item) {
        console.log(`sending steps from track uuid ${this.track.track_uuid}...`)
        this.track.track_detections = this.track.track_detections.filter(step => !this.toDrag.has(step.step_id))
        this.clear()
        if (this.track.track_detections.length === 0) {
          this.$emit('empty-track')
        }
    },
    scrollWindow(event) {
      // TODO set up scrolling
    },
    async onDrop(event, track) {
      const stepsData = event.dataTransfer.getData('steps')
      console.log(stepsData)
      if (!stepsData) {
        return
      }
      const steps = JSON.parse(stepsData)
      const trackUUID = JSON.parse(event.dataTransfer.getData('trackUuid'))
      console.log(`sending steps to track uuid ${this.track.track_uuid}...`)

      console.log(steps)
      this.merging = true
      const { data } = await updateTracks({
        domainUUID: this.domainUUID,
        payload: steps.map(step => ({ step_id: step.step_id, track_uuid: this.track.track_uuid })),
        originalTrackUUID: trackUUID,
      })
      this.merging = false
      this.track.track_detections.push(...data.steps)
      console.log(event, track)
    },
    // async submitAndHide() {
    //   const payload = Object.entries(this.stepState)
    //       .filter(([stepId, stepState]) => stepState !== this.states.INDETERMINATE)
    //       .map(([stepId, stepState]) => ({ 'step_id': parseInt(stepId), is_false_positive: stepState === this.states.FALSE_POSITIVE }))
    //   await confirmTracks({ domainUUID: this.domainUUID, payload })
    //   this.hidden = true
    // },
    /**
     * Returns the unix offset, in milliseconds, represented by a string timestamp.
     * @param timestamp A timestamp string.
     * @returns An offset, in milliseconds, from the Unix epoch date.
     */
    unixOffsetFromTimestamp (timestamp) {
      return moment(timestamp).valueOf()
    },
    displayVideo () {
      this.$router.push({
        path: `/view/${this.detection.camera_uuid}/${this.detection.captured_at}`,
      })
    },
    handleClose: function (payload) {
      this.showAddFace = false
    },
    async loadImageAsBase64 (url) {
      const response = await fetch(url)
      const img = await response.blob()
      const dataURL = await new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = e => resolve(e.target.result)
        reader.readAsDataURL(img)
      })
      return dataURL
    },
  },
  computed: {
    ...mapGetters({
      // frontendFaces: 'frontendFaces',
      domainUUID: 'currentDomainUUID',
      cameraForUUID: 'cameraForUUID',

    }),
    posterButtons () {
      return [
        new OwalButtonConfiguration({
          title: 'Full Frame',
          identifier: 'image',
          url: 'google.com', // this.detection.frame_uri,
          alignment: 'center',
          accessoryType: 'none',
        }),
        new OwalButtonConfiguration({
          title: 'Video',
          identifier: 'video',
          url: 'google.com', // `${window.location.protocol}//${window.location.host}/view/${this.detection.camera_uuid}/${moment.utc(this.detection.captured_at, 'ddd, DD MMM YYYY HH:mm:ss Z').format()}`,
          alignment: 'center',
          accessoryType: 'none',
        }),
        // new OwalButtonConfiguration({
        //   title: 'Not a Face',
        //   identifier: 'not-face',
        //   callback: this.notAFaceClicked,
        //   alignment: 'center',
        //   accessoryType: 'none',
        //   destructive: true,
        // }),
      ]
    },
    cropped_frame_uri () {
      const url = new URL('https://svc-d.api.owal.io/api/v7/faces/detected/mG3V4MK3QK9VgakM/image?cropped=0') // URL(this.detection.frame_uri)
      url.searchParams.set('cropped', '1')
      return url.toString()
    },
  },
}
</script>

<style scoped>

.owal.flex.row {
  display: flex;
  flex-direction: row;
  height: 100%;
  /*flex-shrink: 0;*/
  /*flex-grow: 1;*/
}

.owal.matches.container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  align-content: center;
  flex-grow: 1;
  height: 100%;
}

.owal-traininig-tool-detection-banner__container {
  display: flex;
  flex: initial;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  /*width: 68.5714285714rem;*/
}

.owal.matches.container .owal.potential.match.container {
  flex-shrink: 0;
  height: 100%;
}

/* --- Based on https://codepen.io/shshaw/pen/wWQZEB --- */

/* Prevents :hover from triggering in the gaps between items */
.owal.matches.container {
   visibility: hidden;
}

/* Brings the child items back in, even though the parent is `hidden` */
.owal.matches.container > * {
  visibility: visible;
}

/* Makes the fades smooth with a slight delay to prevent jumps as the mouse moves between items. */
.owal.matches.container > * {
  transition: opacity 150ms linear 100ms, transform 150ms ease 100ms;
}

/* Fade out all items when the parent is hovered */
.owal.matches.container:hover > * {
  opacity: 0.4;
  transform: scale(0.9);
}

/* Fade in the currently hovered item */
.owal.matches.container > *:hover {
  opacity: 1;
  transform: scale(1);
  transition-delay: 0ms, 0ms;
}

/* --- end fade siblings code --- */

.owal.not.face.button,
.owal.undo.button {
  color: #fff;
  background: rgba(208,2,27, 0.9);
}

.owal.banner.button.area {
  display: flex;
  flex-direction: column;
  align-self: flex-end;
  padding: 0.5rem;
  margin: 0;
  flex-grow: 0;
  flex-shrink: 0;
  max-width: 10.5rem;
  height: 100%;
  align-content: stretch;
  align-items: stretch;
  justify-content: stretch;
}

.owal.banner.button.area .button {
  width: 6rem;
}

/* The buttons that control the non-match interfaces. */
.owal.not.match.button {
  font-family: 'Lato-Italic', 'Avenir-Italic', sans-serif;
  font-size: 0.8571428571rem;
  color: #475669;
  letter-spacing: 0;
  padding: 0.5rem;
  cursor: pointer;
  align-self: flex-end;
}

.owal.banner.button.area input {
  -webkit-appearance: none;
  flex-grow: 0;
  flex-shrink: 0;
  height: 2rem;
  width: 6.2rem;
  padding: 0 0.5rem;
  border: none;
  background: none;
  border-radius: 0.2857142857rem;
  font-family: 'Lato-Italic', 'Avenir-Italic', sans-serif;
  font-size: 0.8571428571rem;
  color: #475669;
  text-align: right;

  letter-spacing: 0;
  align-self: flex-end;
  text-align: right;
  cursor: pointer;

  transition: width 300ms ease, background-color 300ms ease;
}

.owal.banner.button.area input:hover {
  background: #E5E9F2;
}

input::-moz-placeholder,
input::-webkit-input-placeholder,
input::placeholder,
.owal.banner.button.area input:-ms-input-placeholder {
  color: #475669;
  opacity: 1;
}

.owal.banner.button.area input:focus {
  font-family: 'Lato-Regular', 'Avenir-Medium', sans-serif;
  text-align: left;
  background: #E5E9F2;
  border: 1px solid #D3DCE6;
  width: 8rem;
}

/* Add face button */
.owal.add.face.button,
.owal.video.button {
  background: #F0F0F0;
  color: #475669;
  border: 2px solid #E0E0E0;
}

.owal.banner.button.area * {
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  font-family: 'Lato-Regular', 'Avenir', sans-serif;
  font-size: 0.8571428571rem;
  height: 2rem;
  letter-spacing: 0;
  border-radius: 0.25rem;
  cursor: pointer;
  align-self: flex-end;

  padding: 0.5rem;
  margin: 0.5rem 0;
}

.owal.banner.button.area .button:hover {
  transform: scale(1.1);
  opacity: 0.8;
}

.owal.banner.button.area .button {
  transition: opacity 300ms ease, transform 300ms ease;
}

.btn-grp {
  display: flex;
  flex-direction: column;
  margin: 5px;
  max-width: 100px;
  min-width: 100px;
}

.btn-grp > button {
  margin: 2px;
}

.btn-grp > button:last-child {
  margin-top: auto;
}

.flex-end {
  align-self: flex-end;
}

.flex-end > button {
  margin: 5px;
}

.submitted {
  min-width: 1079px;
}

.scrollable {
  min-width: 900px;
  display: flex;
  flex-wrap: wrap;
  flex-grow: 1;
}

.unselected {
  border: white solid 3px;
}

.selected {
  border: green solid 3px;
}

.falsePositive {
  border: red solid 3px;
}
</style>
